module.exports = __webpack_public_path__ + "images/assets/ee7ebf2079e1566b1741ddd19202e545.svg";